import module from 'contabilidad/catalogosexternos/module.js'
import template from './template.html'

export class CatalogosExternosSucursalCuentasContablesSucursalesEditarInicializarComponent{
  idSucursal
  onClose = undefined

  confirmar(){
    this.accion = "INICIALIZAR"
    this.text = "¿Quieres inicializar las cuentas contables?"
    this.confirmando = true;
  }

  procesado(){
    this.confirmando = false;
    this.onClose();
  }
}

module.component('contabilidadCatalogosexternosSucursalesEditarInicializar', {
  controller: CatalogosExternosSucursalCuentasContablesSucursalesEditarInicializarComponent,
  template,
  bindings: {
    idSucursal: '<',
    familias: '<',
    onClose: '&'
  }
})


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/components/sucursales/editar/inicializar/component.js